import { gql } from "@apollo/client";

export const CAMBIAR_PROGRAMA_EVALUACION = gql`
mutation CambiarProgramaContrato($idEvaluacion: Int!, $tipoNotificacionAsistencial: TipoNotificacionAsistencial!) {
    cambiarProgramaContrato(idEvaluacion: $idEvaluacion, tipoNotificacionAsistencial: $tipoNotificacionAsistencial) {
        success
        error
        valorEsperado {
            idControlRI
        }
    }
}`;